import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "12px",
  },
  filterBtnGroup: {
    padding: "4px",
    background: "#181D1F08",
  },
  tooltip: {
    backgroundColor: "black !important",
  },
  activeFilterBtn: {
    background: "#0F56CA !important",
    border: "1px solid #0F56CA !important",
    color: "white !important",
  },
  table: {
    borderTop: "1px solid #CCCCCC",
  },
  textUnderline: {
    // textDecoration: "underline dotted",
    textDecoration: "underline",
    textDecorationColor: "#202020",
    textUnderlineOffset: "2px",
  },
  clickable: {
    cursor: "copy !important",
  },
}));
